import { InfoCircleTwoTone, LockOutlined, WarningOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import { AlertProps } from 'antd/lib/alert';
import React from 'react';

import { UserAlert, UserAlertSeverity } from '../../graphql/api/generated';

import { EmergencyScenarioAlertTitle } from './EmergencyScenarioAlertTitle';

interface IUserAlertBannersProps {
  userAlerts: UserAlert[];
}

const ANTD_ALERT_TYPE_MAP: { [severity in UserAlertSeverity]: AlertProps['type'] } = {
  [UserAlertSeverity.CRITICAL]: 'error',
  [UserAlertSeverity.EMERGENCY]: 'error',
  [UserAlertSeverity.INFO]: 'info',
  [UserAlertSeverity.WARNING]: 'warning',
};

const ICON_MAP: { [severity in UserAlertSeverity]: React.FC } = {
  [UserAlertSeverity.CRITICAL]: LockOutlined,
  [UserAlertSeverity.EMERGENCY]: LockOutlined,
  [UserAlertSeverity.INFO]: InfoCircleTwoTone,
  [UserAlertSeverity.WARNING]: WarningOutlined,
}

export const UserAlertBanners: React.FC<IUserAlertBannersProps> = ({ userAlerts }) => {
  if (!userAlerts.length) {
    return null;
  }

  return (
    <div style={{ width: '100%' }}>
      {userAlerts.map((userAlert, index) => {
        const { type, severity, description, payload } = userAlert;

        let formattedTitle: React.ReactNode = userAlert.title;

        if (type === 'EMERGENCY_SCENARIO_ACTIVE' && payload?.emergencyScenario) {
          formattedTitle = (
            <EmergencyScenarioAlertTitle emergencyScenario={payload.emergencyScenario} />
          );
        }

        const Icon = ICON_MAP[severity];

        return (
          <Alert
            key={index}
            banner
            type={ANTD_ALERT_TYPE_MAP[severity]}
            icon={Icon ? <Icon /> : undefined}
            message={formattedTitle}
            // Force component to render with larger font/icon size by adding an element,
            // even if there is no description available.
            description={<>{description}</>}
          />
        );
      })}
    </div>
  );
};
